<template>
    <div>
    <a-row>
      <a-col :span="4">
      </a-col>
      <a-col :span="16">
          <div class="title">
                经济学院专业技术人员年度考核表（本科教学）
          </div>
      </a-col>
      <a-col :span="4">
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="8">
      </a-col>
      <a-col :span="8">
          <div class="schoolYear">
                {{schoolYear}}学年
          </div>
      </a-col>
      <a-col :span="8">
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="8">
      </a-col>
      <a-col :span="4">
          <div class="schoolYear">
                教师姓名：{{teacherName}}
          </div>
      </a-col>
      <a-col :span="4">
          <div class="schoolYear">
                教师编号：{{teacherId}}
          </div>
      </a-col>
      <!-- <a-col :span="4">
          <div class="schoolYear">
            专技职务：{{technicalTitleName}}
          </div>
      </a-col> -->
      <a-col :span="8">
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="2">
      </a-col>
      <a-col :span="20">
          <a-table :columns="columns" :data-source="data" :pagination='false' :showHeader='false' size='small' bordered>
        </a-table>
        <a-row v-if="confirmStatus == 'Y'">
        <a-col :span="4" class="qr">
            确认总分：{{totalScore}}
        </a-col>
        <a-col :span="4" class="qr">
            确认人：{{teacherName}}
        </a-col>
        <a-col :span="6" class="qr">
            确认时间：{{confirmTime}}
        </a-col>
        <a-col :span="10">
        </a-col>
        </a-row>
      </a-col>
      
      <a-col :span="2">
      </a-col>
    </a-row>
  
    <div class="btn-box">
        <a-button type="primary" v-if="confirmStatus != 'Y' && $store.state.user.userId == teacherId"  @click="confirm">确认</a-button>
    <a-button @click="$router.go(-1)">取消</a-button>
    </div>
  </div>
  
</template>
<script>
import { info,confirm } from '@/baseAPI/undergraduate/culture/assess'

export default {
  data() {
    const columns = [
      {
        title: '',
        dataIndex: 'dataName',
        width:250,
        customRender: (text, row, index) => {
            const obj = {
                children: text,
                attrs: {},
            };
            if (index == 0) {
                obj.attrs.rowSpan = this.jxjfSize;
            }
            if (row.dataCode == 'JXJF' && index > 0 && index < this.jxjfSize) {
                obj.attrs.rowSpan = 0;
            }

            if (row.dataCode == 'KCJSXM' && index == this.jxjfSize) {
                obj.attrs.rowSpan = this.kcjsxmSize;
            }

            if (row.dataCode == 'KCJSXM' && index > this.jxjfSize  && index < this.jxjfSize + this.kcjsxmSize) {
                obj.attrs.rowSpan = 0;
            }
            if (row.dataCode == 'QCDS' && index == this.jxjfSize + this.kcjsxmSize) {
                obj.attrs.rowSpan = this.qcdsSize;
            }

            if (row.dataCode == 'QCDS' && index > this.jxjfSize + this.kcjsxmSize  && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize) {
                obj.attrs.rowSpan = 0;
            }

            if (row.dataCode == 'BKPY-QT' && index == this.jxjfSize + this.kcjsxmSize + this.qcdsSize) {
                obj.attrs.rowSpan = this.bkpyqtSize;
            }

            if (row.dataCode == 'BKPY-QT' && index > this.jxjfSize + this.kcjsxmSize + this.qcdsSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize) {
                obj.attrs.rowSpan = 0;
            }

            if (row.dataCode == 'JK' && index == this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize) {
                obj.attrs.rowSpan = this.jkSize;
            }

            if (row.dataCode == 'JK' && index > this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize) {
                obj.attrs.rowSpan = 0;
            }

            if (row.dataCode == 'QT' && index == this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize) {
                obj.attrs.rowSpan = this.qtSize;
            }

            if (row.dataCode == 'QT' && index > this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize + this.qtSize) {
                obj.attrs.rowSpan = 0;
            }

            return obj;
        },
      },
      {
        title: '',
        dataIndex: 'val1',
        align: 'left',
        customRender: (text, row, index) => {
            const obj = {
                children: text,
                attrs: {},
            };
            if (index == 0) {
                obj.attrs.colSpan = 3;
            }
            if(row.dataCode == 'JXJF' && index > 0 && index < this.jxjfSize){
                obj.attrs.colSpan = 3;
            }

            if (row.dataCode == 'KCJSXM' && index >= this.jxjfSize && index < this.jxjfSize + this.kcjsxmSize) {
                obj.attrs.colSpan = 3;
            }

            if (row.dataCode == 'QCDS' && index >= this.jxjfSize + this.kcjsxmSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize - 1) {
                obj.attrs.colSpan = 2;
            }

            if (row.dataCode == 'QCDS' && index == this.jxjfSize + this.kcjsxmSize + this.qcdsSize - 1) {
                obj.attrs.colSpan = 3;
            }
            if (row.dataCode == 'BKPY-QT' && index >= this.jxjfSize + this.kcjsxmSize + this.qcdsSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize) {
                obj.attrs.colSpan = 3;
            }
            if (row.dataCode == 'JK' && index ==  this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize - 1) {
                obj.attrs.colSpan = 3;
            }
            if (row.dataCode == 'QT' && index >= this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize + this.qtSize) {
                obj.attrs.colSpan = 3;
            }
            return obj;
        },
      },
      {
        title: '',
        dataIndex: 'val2',
        align: 'left',
        customRender: (text, row, index) => {
            const obj = {
                children: text,
                attrs: {},
            };
            if (index === 0) {
                obj.attrs.colSpan = 0;
            }
            if(row.dataCode == 'JXJF' && index > 0 && index < this.jxjfSize){
                obj.attrs.colSpan = 0;
            }

            if(row.dataCode == 'KCJSXM' && index >= this.jxjfSize && index < this.jxjfSize + this.kcjsxmSize){
                obj.attrs.colSpan = 0;
            }

            if(row.dataCode == 'QCDS' && index >= this.jxjfSize + this.kcjsxmSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize){
                obj.attrs.colSpan = 0;
            }

            if (row.dataCode == 'QCDS' && index == this.jxjfSize + this.kcjsxmSize + this.qcdsSize - 1) {
                obj.attrs.colSpan = 0;
            }
            if (row.dataCode == 'BKPY-QT' && index >= this.jxjfSize + this.kcjsxmSize + this.qcdsSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize) {
                obj.attrs.colSpan = 0;
            }
            if (row.dataCode == 'JK' && index ==  this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize - 1) {
                obj.attrs.colSpan = 0;
            }
            if (row.dataCode == 'QT' && index >= this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize + this.qtSize) {
                obj.attrs.colSpan = 0;
            }
            return obj;
        },
      },
      {
        title: '',
        dataIndex: 'val3',
        align:'left',
        customRender: (text, row, index) => {
            const obj = {
                children: text,
                attrs: {},
            };
            if(row.dataCode == 'JXJF' && index >= 0 && index < this.jxjfSize){
                obj.attrs.colSpan = 0;
            }
            if(row.dataCode == 'KCJSXM' && index >= this.jxjfSize && index < this.jxjfSize + this.kcjsxmSize){
                obj.attrs.colSpan = 0;
            }
            if (row.dataCode == 'QCDS' && index == this.jxjfSize + this.kcjsxmSize + this.qcdsSize - 1) {
                obj.attrs.colSpan = 0;
            }
            if (row.dataCode == 'BKPY-QT' && index >= this.jxjfSize + this.kcjsxmSize + this.qcdsSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize) {
                obj.attrs.colSpan = 0;
            }
            if (row.dataCode == 'JK' && index ==  this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize - 1) {
                obj.attrs.colSpan = 0;
            }
            if (row.dataCode == 'QT' && index >= this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize && index < this.jxjfSize + this.kcjsxmSize + this.qcdsSize + this.bkpyqtSize + this.jkSize + this.qtSize) {
                obj.attrs.colSpan = 0;
            }
            return obj;
        },
      },
      {
        title: '',
        align:'center',
        dataIndex: 'val',
      },
    ];
    return {
    //   data:[{
    //             "dataName": <p style="font-weight:bold">全程导师工作量</p>,
    //             "val1": <p style="font-weight:bold;text-align: center">人数</p>,
    //             "val2": "人数",
    //             "val3": <p style="font-weight:bold;text-align: center">标准</p>,
    //             "val": <p style="font-weight:bold">核定分值</p>
    //         }],
        data:[],
      columns,
      result:[],
      qcdsSize: 0,
      jkSize: 0,
      jxjfSize: 0,
      kcjsxmSize: 0,
      qtSize: 0,
      bkpyqtSize:0,
      teacherName:'',
      teacherId:'',
      schoolYear:'',
      technicalTitleName:'',
      confirmStatus:'',
      confirmTime:'',
      totalScore:0
    };
  },
  mounted(){
      this.schoolYear = this.$route.query.schoolYear;
      this.teacherId = this.$route.query.teacherId;
      setTimeout(()=>{
        this.fetch()
      },100)
  },
  methods:{
      confirm(){
          confirm(this.teacherId,this.schoolYear).then(res=>{
                if(res.data.success){
                    this.$notification['success']({
                        message: '成功',
                        description:'确认成功！',
                    });
                    this.$router.go(-1)
                }else{
                    this.$notification['error']({
                        message: '失败',
                        description:res.data.errorMessage,
                    });
                }
          })
      },
      fetch(){
        info(this.teacherId,this.schoolYear).then(res=>{
            this.teacherName = res.data.teacherName;
            this.confirmTime = res.data.confirmTime;
            this.confirmStatus = res.data.confirmStatus;
            this.technicalTitleName = res.data.technicalTitleName;
            this.result = res.data.assessGroups;
            this.totalScore = res.data.totalScore

            this.result.forEach(element => {
                if(element.dataCode == 'JXJF'&& element.details!= null){
                    this.jxjfSize = element.details.length + 2;
                    this.data.push({
                        "dataCode": "JXJF",
                        "dataName": <p style="font-weight:bold">{element.dataName}</p>,
                        "val1": <p style="font-weight:bold;text-align: center">项目</p>,
                        "val": <p style="font-weight:bold">教分</p>
                    });
                    element.details.forEach(qcds=>{
                        this.data.push(qcds)
                    })
                    this.data.push({
                        "dataCode":"JXJF",
                        "val1": <p style="font-weight:bold">核定分值小计：</p>,
                        "val": element.subTotal
                    });
                }
            })

            this.result.forEach(element => {
                if(element.dataCode == 'KCJSXM' && element.details!= null){
                    this.kcjsxmSize = element.details.length + 2;
                    this.data.push({
                        "dataCode": "KCJSXM",
                        "dataName": <p style="font-weight:bold">{element.dataName}</p>,
                        "val1": <p style="font-weight:bold;text-align: center">项目</p>,
                        "val": <p style="font-weight:bold">教分</p>
                    });
                    element.details.forEach(qcds=>{
                        this.data.push(qcds)
                    })
                    this.data.push({
                        "dataCode":"KCJSXM",
                        "val1": <p style="font-weight:bold">核定分值小计：</p>,
                        "val": element.subTotal
                    });
                }
            })

            this.result.forEach(element => {
                if(element.dataCode == 'QCDS'&& element.details != null){
                    this.qcdsSize = element.details.length + 2;
                    console.log("qcdsSize:"+this.qcdsSize)
                    this.data.push({
                        "dataName": <p style="font-weight:bold">{element.dataName}</p>,
                        "dataCode":"QCDS",
                        "val1": <p style="font-weight:bold;text-align: center">人数</p>,
                        "val2": "人数",
                        "val3": <p style="font-weight:bold;text-align: center">标准</p>,
                        "val": <p style="font-weight:bold">核定分值</p>
                    })
                    element.details.forEach(qcds=>{
                        qcds.val3=qcds.val2;
                        qcds.val2=null;
                        this.data.push(qcds)
                    })
                    this.data.push({
                        "dataCode":"QCDS",
                        "val1":  <p style="font-weight:bold">核定分值小计：</p>,
                        "val": element.subTotal
                    });
                }

                // if(element.dataCode == 'QCDS'&& element.details == null){
                //     this.qcdsSize = 3;
                //     this.data.push({
                //         "dataCode": "QCDS",
                //         "dataName": "全程导师工作量",
                //         "val1": "0",
                //         "val2": "",
                //         "val3": "",
                //         "val": 0
				//     });
                //     this.data.push({
                //         "dataCode":"QCDS",
                //         "val1":  <p style="font-weight:bold">核定分值小计：</p>,
                //         "val": 0
                //     });
                // }
            });

            this.result.forEach(element => {
                if(element.dataCode == 'BKPY-QT'&& element.details!= null){
                    this.bkpyqtSize = element.details.length + 2;
                    this.data.push({
                        "dataCode": "BKPY-QT",
                        "dataName": <p style="font-weight:bold">{element.dataName}</p>,
                        "val1": <p style="font-weight:bold;text-align: center">项目</p>,
                        "val": <p style="font-weight:bold">教分</p>
                    });
                    element.details.forEach(qcds=>{
                        this.data.push(qcds)
                    })
                    this.data.push({
                        "dataCode":"BKPY-QT",
                        "val1": <p style="font-weight:bold">核定分值小计：</p>,
                        "val": element.subTotal
                    });
                }
            })


            this.result.forEach(element => {
                if(element.dataCode == 'JK'&& element.details!= null){
                    this.jkSize = element.details.length + 2;
                    this.data.push({
                        "dataCode": "JK",
                        "dataName": <p style="font-weight:bold">{element.dataName}</p>,
                        "val1": <p style="font-weight:bold;text-align: center">学期</p>,
                        "val2": <p style="font-weight:bold;text-align: center">场次</p>,
                        "val3": <p style="font-weight:bold;text-align: center">标准</p>,
                        "val": <p style="font-weight:bold">核定分值</p>
                    });
                    element.details.forEach(qcds=>{
                        this.data.push(qcds)
                    })
                    this.data.push({
                        "dataCode":"JK",
                        "val1": <p style="font-weight:bold">核定分值小计：</p>,
                        "val": element.subTotal
                    });
                }
            })

            this.result.forEach(element => {
                if(element.dataCode == 'QT'&& element.details!= null){
                    this.qtSize = element.details.length + 2;
                    this.data.push({
                        "dataCode": "QT",
                        "dataName": <p style="font-weight:bold">{element.dataName}</p>,
                        "val1": <p style="font-weight:bold;text-align: center">项目</p>,
                        "val": <p style="font-weight:bold">教分</p>
                    });
                    element.details.forEach(qcds=>{
                        this.data.push(qcds)
                    })
                    this.data.push({
                        "dataCode":"QT",
                        "val1": <p style="font-weight:bold">核定分值小计：</p>,
                        "val": element.subTotal
                    });
                }
            })

            this.data.push({
                "dataCode": "HDZF",
                "dataName": <p style="font-weight:bold">核定总分</p>,
                "val1": res.data.totalScore,
                "val3":<p style="font-weight:bold">核定人：姚青琪</p>
            });

            console.log(this.data)

        })

      }

      
  }
};
</script>
<style scoped>

.title{
    font-weight:bold;
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 1rem;
}

.schoolYear{
    margin-bottom: 1rem;
    text-align: center;
}

.qr{
    font-weight:bold;
    margin-left: 1rem;
    margin-top: 1rem;
}

.qr-button{
    text-align: center;
    margin-top: 1rem;
}

    .btn-box{
        text-align: center;
        margin-top: 1rem;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }

</style>